import { render } from "./EmptyContentBlock.vue?vue&type=template&id=4421ae78&scoped=true"
import script from "./EmptyContentBlock.vue?vue&type=script&lang=js"
export * from "./EmptyContentBlock.vue?vue&type=script&lang=js"

import "./EmptyContentBlock.vue?vue&type=style&index=0&id=4421ae78&scoped=true&lang=css"

import exportComponent from "/media/dolar/office/office_project/barmm-admin-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4421ae78"]])

export default __exports__